import _ from 'lodash';
import URI from 'urijs';
import { HITLBase } from './HITLBase';
export class Filters extends HITLBase {
    static getFilters(options = {}) {
        const route = this.getBaseUrl(options);
        const params = _.pick(options, ['id', 'agentId']);
        return this.request({
            method: 'GET',
            route,
            params,
        });
    }
    static bulkGetFilters(options = {}) {
        const baseUrl = this.getBaseUrl(options);
        const route = new URI(baseUrl).segment(this.BULK_URL).href();
        return this.request({
            method: 'GET',
            route,
        });
    }
    static createFilter(options) {
        const route = this.getBaseUrl(options);
        const params = _.pick(options, ['isCommon', 'agentId']);
        const data = _.pick(options, ['name', 'settings', 'order', 'isDefault']);
        return this.request({
            method: 'POST',
            route,
            params,
            data,
        });
    }
    static updateFilter(options) {
        const route = this.getBaseUrl(options);
        const data = _.pick(options, [
            'id',
            'name',
            'settings',
            'order',
            'isDefault',
        ]);
        return this.request({
            method: 'PUT',
            route,
            data,
        });
    }
    static bulkUpdateFilters(options) {
        const baseUrl = this.getBaseUrl(options);
        const route = new URI(baseUrl).segment(this.BULK_URL).href();
        const data = {
            filters: options === null || options === void 0 ? void 0 : options.filters.map(filter => _.pick(filter, [
                'id',
                'name',
                'settings',
                'order',
                'isDefault',
            ])),
        };
        return this.request({
            method: 'PUT',
            route,
            data,
        });
    }
    static deleteFilter(options) {
        const route = this.getBaseUrl(options);
        const params = _.pick(options, ['id']);
        return this.request({
            method: 'DELETE',
            route,
            params,
        });
    }
}
Filters.MODULE_URL = 'filters';
Filters.BULK_URL = 'bulk';
//# sourceMappingURL=Filters.js.map